import Slider from "react-slick";
import { Box, Typography } from "@mui/material";
import { Image } from "mui-image";
import { ImageCarouselProps } from "../../types";
import { useState } from "react";
import FreshnessMeter from "./FreshnessMeter";
import FreshnessDetailModal from "./FreshnessDetailModal";

export default function ImageCarousel({ images, freshnessMeterDetails, isInModal, loading }: ImageCarouselProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const freshnessData = freshnessMeterDetails;
  const positiononModal = freshnessData?.freshness !== "Not Fresh" ? 4 : 95;
  const position = freshnessData?.freshness !== "Not Fresh" ? 6 : 95;

  var settings = {
    dots: true,
    infinite: images.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
  };


  return (
    <>
      {!loading && images.length === 0 ? (
        <Box
          sx={{
            height: isInModal ? "150px" : "260px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f5f5",
            borderRadius: 1,
          }}
        >
          <Typography variant="caption" color="gray">
            No Images Available
          </Typography>
        </Box>
      ) : (
        <Slider {...settings}>
          {images.map((image, index) => (
            <Box
              key={index}
              sx={{ height: isInModal ? "150px" : "260px", textAlign: "center", position: "relative", bgcolor: "#f5f5f5", }}
            >
              <Image
                src={image.src}
                style={{ objectFit: "contain", position: "relative" }}
                alt="trace"
              />
              {freshnessData && (
                <Box sx={{ position: "absolute", top: 2, display: "flex", justifyContent: "center" }}>
                  <FreshnessMeter
                    position={position}
                    onClick={() => setIsModalOpen(true)}
                  />
                </Box>
              )}
            </Box>
          ))}
        </Slider>
      )}
      {freshnessData && (
        <FreshnessDetailModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          position={positiononModal}
          details={freshnessData}
        />
      )}
    </>
  );
}